import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '@/firebase/config';
import { Organization } from '@/firebase/organizationService';

/**
 * Extract domain from email address
 */
export const extractDomainFromEmail = (email: string): string | null => {
  const parts = email.split('@');
  if (parts.length !== 2) {
    return null;
  }
  return parts[1].toLowerCase();
};

/**
 * Find organization with SSO enabled for a given email domain
 */
export const findOrganizationBySSODomain = async (email: string): Promise<Organization | null> => {
  try {
    const domain = extractDomainFromEmail(email);
    if (!domain) {
      return null;
    }

    // Get all organizations and filter in memory
    // Note: Firestore doesn't support nested field queries like 'sso.enabled' directly
    // We'll fetch all organizations and filter client-side
    const organizationsRef = collection(db, 'organizations');
    const querySnapshot = await getDocs(organizationsRef);
    
    // Filter organizations with SSO enabled for this domain
    for (const doc of querySnapshot.docs) {
      const orgData = doc.data();
      if (
        orgData.sso?.enabled === true &&
        orgData.sso?.domain?.toLowerCase() === domain.toLowerCase()
      ) {
        return {
          id: doc.id,
          ...orgData,
        } as Organization;
      }
    }

    return null;
  } catch (error: any) {
    console.error('Error finding organization by SSO domain:', error);
    // If query fails, return null
    return null;
  }
};

/**
 * Check if an email domain has SSO configured
 */
export const hasSSOForDomain = async (email: string): Promise<boolean> => {
  const org = await findOrganizationBySSODomain(email);
  return org !== null;
};

